module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/kidney-e262a09cd53e52b2df366ad7fc72e593.png";